import React from "react";

const BackgroundAccents = () => {
  return (
    <div className="absolute inset-0 overflow-hidden">
      <div className="absolute w-48 h-48 sm:w-56 sm:h-56 md:w-72 md:h-72 bg-yellow-200 top-[-40px] left-[-40px] rotate-6 rounded-lg"></div>
      <div className="absolute w-40 h-40 sm:w-52 sm:h-52 md:w-64 md:h-64 bg-yellow-300 bottom-[-40px] right-[-40px] -rotate-6 rounded-lg"></div>
      <div className="absolute w-44 h-44 sm:w-52 sm:h-52 md:w-56 md:h-56 bg-yellow-100 top-1/3 left-1/4 -translate-x-1/2 -translate-y-1/2 rotate-3 rounded-lg"></div>
      <div className="absolute w-60 h-60 sm:w-72 sm:h-72 md:w-80 md:h-80 bg-yellow-400 bottom-1/4 right-1/3 translate-x-1/2 translate-y-1/2 -rotate-12 rounded-lg"></div>
    </div>
  );
};

export default BackgroundAccents;
